(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  function alInicializar() {
    var barras = document.querySelectorAll('[data-barra-promociones-enterprise]');
    barras.forEach(function (barra) {
      var pista = barra.querySelector('[data-pista-promociones]');
      var slides = barra.querySelectorAll('[data-slide-promocion]');
      var botonAnterior = barra.querySelector('[data-flecha-anterior]');
      var botonSiguiente = barra.querySelector('[data-flecha-siguiente]');

      if (!pista || slides.length === 0) return;

      var indiceActual = 0;

      function mostrarSlide(indice) {
        slides.forEach(function (slide, i) {
          if (i === indice) {
            slide.classList.add('barra-promociones-enterprise__slide--activo');
          } else {
            slide.classList.remove('barra-promociones-enterprise__slide--activo');
          }
        });
      }

      function irSiguiente() {
        indiceActual = (indiceActual + 1) % slides.length;
        mostrarSlide(indiceActual);
      }

      function irAnterior() {
        indiceActual = (indiceActual - 1 + slides.length) % slides.length;
        mostrarSlide(indiceActual);
      }

      mostrarSlide(indiceActual);

      if (botonSiguiente) {
        botonSiguiente.addEventListener('click', function () {
          irSiguiente();
          reiniciarAutoplay();
        });
      }

      if (botonAnterior) {
        botonAnterior.addEventListener('click', function () {
          irAnterior();
          reiniciarAutoplay();
        });
      }

      var temporizadorAutoplay = null;

      function reiniciarAutoplay() {
        if (temporizadorAutoplay) clearInterval(temporizadorAutoplay);
        if (slides.length > 1) {
          temporizadorAutoplay = setInterval(irSiguiente, 5000);
        }
      }

      reiniciarAutoplay();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alInicializar);
  } else {
    alInicializar();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barra-navegacion-movil"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.tcvBarraMovilInicializada) return;
  window.tcvBarraMovilInicializada = true;

  function inicializarBarra(barra) {
    var botonBuscar = barra.querySelector('[data-barra-movil-buscar]');
    if (botonBuscar) {
      botonBuscar.addEventListener('click', function () {
        var input = document.querySelector('[data-input-buscador]');
        if (!input) return;
        input.focus({ preventScroll: true });
        input.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    var botonCarrito = barra.querySelector('[data-barra-movil-carrito]');
    if (botonCarrito) {
      botonCarrito.addEventListener('click', function (evento) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          evento.preventDefault();
          drawer.open();
        }
      });
    }

    function actualizarEspaciado() {
      var visible = window.getComputedStyle(barra).display !== 'none';
      var altura = visible ? barra.offsetHeight : 0;
      document.body.style.setProperty('--bnm-espacio-inferior', altura + 'px');
    }

    actualizarEspaciado();
    window.addEventListener('resize', actualizarEspaciado);

    var contadorBarra = barra.querySelector('[data-barra-movil-contador]');
    if (contadorBarra) {
      var origenContador = document.querySelector('.cabecera-enterprise__icono-carrito');
      if (origenContador) {
        var sincronizarContador = function () {
          var origen = origenContador.querySelector('.cabecera-enterprise__contador-carrito');
          var cantidad = origen ? origen.textContent.trim() : '0';
          if (origen && cantidad && cantidad !== '0') {
            contadorBarra.textContent = cantidad;
            contadorBarra.classList.remove('barra-navegacion-movil__badge--oculto');
          } else {
            contadorBarra.textContent = '0';
            contadorBarra.classList.add('barra-navegacion-movil__badge--oculto');
          }
        };
        sincronizarContador();
        var observador = new MutationObserver(sincronizarContador);
        observador.observe(origenContador, { childList: true, subtree: true, characterData: true });
      }
    }
  }

  document.querySelectorAll('[data-barra-navegacion-movil]').forEach(inicializarBarra);

  document.addEventListener('shopify:section:load', function (evento) {
    var barra = evento.target.querySelector('[data-barra-navegacion-movil]');
    if (barra) inicializarBarra(barra);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carrusel-mas-vendidos"] && !Shopify.designMode) return;
  try {
    
(function () {
  var temporizadorNotificacionMasVendidos = null;

  function obtenerNotificacionMasVendidos() {
    return document.getElementById('carrusel-mas-vendidos-notificacion-carrito');
  }

  var notificacionMasVendidosMovidaAlBody = obtenerNotificacionMasVendidos();
  if (notificacionMasVendidosMovidaAlBody && notificacionMasVendidosMovidaAlBody.parentNode !== document.body) {
    document.body.appendChild(notificacionMasVendidosMovidaAlBody);
  }

  function posicionarNotificacionMasVendidosDebajoDelEncabezado() {
    var notificacion = obtenerNotificacionMasVendidos();
    if (!notificacion) return;
    var encabezado = document.querySelector('.cabecera-enterprise') || document.getElementById('shopify-section-header');
    var alturaEncabezado = encabezado ? encabezado.getBoundingClientRect().height : 0;
    notificacion.style.setProperty('--carrusel-mas-vendidos-desplazamiento-superior', alturaEncabezado + 'px');
  }

  posicionarNotificacionMasVendidosDebajoDelEncabezado();
  window.addEventListener('resize', posicionarNotificacionMasVendidosDebajoDelEncabezado);

  function mostrarNotificacionMasVendidos() {
    var notificacion = obtenerNotificacionMasVendidos();
    if (!notificacion) return;
    posicionarNotificacionMasVendidosDebajoDelEncabezado();
    notificacion.classList.add('carrusel-mas-vendidos__notificacion-carrito--activa');
    if (temporizadorNotificacionMasVendidos) window.clearTimeout(temporizadorNotificacionMasVendidos);
    temporizadorNotificacionMasVendidos = window.setTimeout(function () {
      notificacion.classList.remove('carrusel-mas-vendidos__notificacion-carrito--activa');
    }, 5000);
  }

  document.addEventListener('click', function (evento) {
    var botonCerrar = evento.target.closest('[data-cerrar-notificacion-carrito]');
    if (!botonCerrar) return;
    var notificacion = obtenerNotificacionMasVendidos();
    if (!notificacion) return;
    notificacion.classList.remove('carrusel-mas-vendidos__notificacion-carrito--activa');
    if (temporizadorNotificacionMasVendidos) window.clearTimeout(temporizadorNotificacionMasVendidos);
  });

  function actualizarCajonCarritoTCV(secciones) {
    if (!secciones) return;
    var cajon = document.querySelector('cart-drawer');
    if (!cajon) return;
    var listaSecciones = [
      { id: 'cart-drawer', selector: '#CartDrawer' },
      { id: 'cart-icon-bubble', selector: null }
    ];
    listaSecciones.forEach(function (seccion) {
      var html = secciones[seccion.id];
      if (!html) return;
      var elementoDestino = seccion.selector
        ? document.querySelector(seccion.selector)
        : document.getElementById(seccion.id);
      if (!elementoDestino) return;
      var selectorInterno = seccion.selector || '.shopify-section';
      var documentoParseado = new DOMParser().parseFromString(html, 'text/html');
      var nodoFuente = documentoParseado.querySelector(selectorInterno);
      if (nodoFuente) elementoDestino.innerHTML = nodoFuente.innerHTML;
    });
    cajon.classList.remove('is-empty');
    var itemsCajon = cajon.querySelector('cart-drawer-items');
    if (itemsCajon) itemsCajon.classList.remove('is-empty');
    var overlayCajon = document.getElementById('CartDrawer-Overlay');
    if (overlayCajon && typeof cajon.close === 'function') {
      overlayCajon.addEventListener('click', cajon.close.bind(cajon));
    }
  }

  function obtenerConfigDeseosMasVendidos() {
    var config = window._ReStockConfig;
    if (!config || !config.customer || !config.wishlist || config.wishlist.is_service_active === false) {
      return null;
    }
    return config;
  }

  function sincronizarBotonesDeseosMasVendidos(seccion) {
    var botones = seccion.querySelectorAll('[data-boton-deseos]');
    if (!botones.length) return;
    var config = obtenerConfigDeseosMasVendidos();
    if (!config) {
      botones.forEach(function (boton) {
        boton.hidden = true;
      });
      return;
    }
    var variantesGuardadas = {};
    (config.customer.wishlists || []).forEach(function (listaDeseos) {
      (listaDeseos.items || []).forEach(function (articulo) {
        variantesGuardadas[String(articulo.variant_id)] = true;
      });
    });
    botones.forEach(function (boton) {
      boton.hidden = false;
      var idVariante = boton.getAttribute('data-variante-id');
      var estaGuardado = !!variantesGuardadas[String(idVariante)];
      boton.classList.toggle('carrusel-mas-vendidos__boton-deseos--activo', estaGuardado);
      boton.setAttribute('aria-pressed', estaGuardado ? 'true' : 'false');
    });
  }

  function inicializarCarruselMasVendidos(seccion) {
    var lista = seccion.querySelector('[data-carrusel-lista]');

    function desplazar(direccion) {
      if (!lista) return;
      lista.scrollBy({ left: direccion * lista.clientWidth * 0.9, behavior: 'smooth' });
    }

    var flechaAnterior = seccion.querySelector('[data-carrusel-flecha="anterior"]');
    var flechaSiguiente = seccion.querySelector('[data-carrusel-flecha="siguiente"]');
    if (flechaAnterior) {
      flechaAnterior.addEventListener('click', function () {
        desplazar(-1);
      });
    }
    if (flechaSiguiente) {
      flechaSiguiente.addEventListener('click', function () {
        desplazar(1);
      });
    }

    seccion.querySelectorAll('[data-carrusel-cantidad-menos], [data-carrusel-cantidad-mas]').forEach(function (botonCantidad) {
      botonCantidad.addEventListener('click', function () {
        var envoltura = botonCantidad.closest('[data-carrusel-cantidad-wrapper]');
        if (!envoltura) return;
        var input = envoltura.querySelector('[data-carrusel-cantidad-input]');
        if (!input) return;
        var valorActual = parseInt(input.value, 10);
        if (isNaN(valorActual) || valorActual < 1) valorActual = 1;
        if (botonCantidad.hasAttribute('data-carrusel-cantidad-mas')) {
          valorActual += 1;
        } else if (valorActual > 1) {
          valorActual -= 1;
        }
        input.value = valorActual;
      });
    });

    seccion.querySelectorAll('[data-carrusel-cantidad-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        var valor = parseInt(input.value, 10);
        if (isNaN(valor) || valor < 1) valor = 1;
        input.value = valor;
      });
    });

    seccion.querySelectorAll('[data-agregar-carrito]').forEach(function (boton) {
      boton.addEventListener('click', function (evento) {
        evento.preventDefault();
        evento.stopPropagation();
        if (boton.hasAttribute('disabled')) return;
        var idVariante = boton.getAttribute('data-variante-id');
        if (!idVariante || boton.hasAttribute('data-cargando')) return;
        boton.setAttribute('data-cargando', 'true');

        var cantidad = 1;
        var filaCarrito = boton.closest('.carrusel-mas-vendidos__fila-carrito');
        if (filaCarrito) {
          var inputCantidad = filaCarrito.querySelector('[data-carrusel-cantidad-input]');
          if (inputCantidad) {
            var valorCantidad = parseInt(inputCantidad.value, 10);
            if (!isNaN(valorCantidad) && valorCantidad > 0) cantidad = valorCantidad;
          }
        }

        var datosFormulario = new FormData();
        datosFormulario.append('id', idVariante);
        datosFormulario.append('quantity', cantidad);
        datosFormulario.append('sections', 'cart-drawer,cart-icon-bubble');
        datosFormulario.append('sections_url', window.location.pathname);

        var controladorTiempoLimite = new AbortController();
        var temporizadorTiempoLimite = window.setTimeout(function () {
          controladorTiempoLimite.abort();
        }, 12000);

        function finalizarEstadoBotonMasVendidos() {
          window.clearTimeout(temporizadorTiempoLimite);
          boton.removeAttribute('data-cargando');
          boton.classList.remove('carrusel-mas-vendidos__boton-carrito--exito');
          boton.blur();
        }

        fetch('/cart/add.js', {
          method: 'POST',
          body: datosFormulario,
          signal: controladorTiempoLimite.signal,
        })
          .then(function (respuesta) {
            return respuesta.json().then(function (datos) {
              if (!respuesta.ok || datos.status) {
                throw new Error(datos.description || datos.message || 'error');
              }
              return datos;
            });
          })
          .then(function (datos) {
            window.clearTimeout(temporizadorTiempoLimite);
            boton.removeAttribute('data-cargando');
            boton.classList.add('carrusel-mas-vendidos__boton-carrito--exito');
            try {
              actualizarCajonCarritoTCV(datos.sections);
            } catch (errorActualizacion) {
              console.error(errorActualizacion);
            }
            mostrarNotificacionMasVendidos();
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS === 'object') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'carrusel-mas-vendidos',
                productVariantId: idVariante,
                cartData: datos,
              });
            }
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            var inputCantidadReset = filaCarrito ? filaCarrito.querySelector('[data-carrusel-cantidad-input]') : null;
            if (inputCantidadReset) inputCantidadReset.value = 1;
            window.setTimeout(function () {
              boton.classList.remove('carrusel-mas-vendidos__boton-carrito--exito');
              boton.blur();
            }, 1600);
          })
          .catch(function (error) {
            console.error(error);
            finalizarEstadoBotonMasVendidos();
          });
      });
    });

    seccion.querySelectorAll('[data-boton-deseos]').forEach(function (boton) {
      boton.addEventListener('click', function (evento) {
        evento.preventDefault();
        evento.stopPropagation();
        if (boton.hasAttribute('data-cargando')) return;
        var config = obtenerConfigDeseosMasVendidos();
        if (!config) return;
        var idProducto = boton.getAttribute('data-producto-id');
        var idVariante = boton.getAttribute('data-variante-id');
        if (!idProducto || !idVariante) return;
        var estabaActivo = boton.classList.contains('carrusel-mas-vendidos__boton-deseos--activo');
        var accion = estabaActivo ? 'remove' : 'add';
        boton.setAttribute('data-cargando', 'true');

        fetch('https://api.notify-me.app/wishlist/wishlist-items/' + accion, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            shop_id: config.shop_id,
            variant_id: parseInt(idVariante, 10),
            product_id: parseInt(idProducto, 10),
            customer_id: config.customer.id,
          }),
        })
          .then(function (respuesta) {
            if (!respuesta.ok) throw new Error('error-boton-deseos');
            var listaActual = config.customer.wishlists && config.customer.wishlists[0];
            if (listaActual) {
              if (accion === 'add') {
                listaActual.items.push({
                  variant_id: parseInt(idVariante, 10),
                  product_id: parseInt(idProducto, 10),
                });
              } else {
                listaActual.items = (listaActual.items || []).filter(function (articulo) {
                  return String(articulo.variant_id) !== String(idVariante);
                });
              }
            }
            boton.classList.toggle('carrusel-mas-vendidos__boton-deseos--activo', accion === 'add');
            boton.setAttribute('aria-pressed', accion === 'add' ? 'true' : 'false');
          })
          .catch(function (error) {
            console.error(error);
          })
          .then(function () {
            boton.removeAttribute('data-cargando');
          });
      });
    });

    sincronizarBotonesDeseosMasVendidos(seccion);
  }

  document.querySelectorAll('[data-carrusel-mas-vendidos]').forEach(inicializarCarruselMasVendidos);

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (evento) {
      var seccion = evento.target.querySelector('[data-carrusel-mas-vendidos]');
      if (seccion) inicializarCarruselMasVendidos(seccion);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carrusel-novedades"] && !Shopify.designMode) return;
  try {
    
(function () {
  var temporizadorNotificacionNovedades = null;

  function obtenerNotificacionNovedades() {
    return document.getElementById('carrusel-novedades-notificacion-carrito');
  }

  var notificacionNovedadesMovidaAlBody = obtenerNotificacionNovedades();
  if (notificacionNovedadesMovidaAlBody && notificacionNovedadesMovidaAlBody.parentNode !== document.body) {
    document.body.appendChild(notificacionNovedadesMovidaAlBody);
  }

  function posicionarNotificacionNovedadesDebajoDelEncabezado() {
    var notificacion = obtenerNotificacionNovedades();
    if (!notificacion) return;
    var encabezado = document.querySelector('.cabecera-enterprise') || document.getElementById('shopify-section-header');
    var alturaEncabezado = encabezado ? encabezado.getBoundingClientRect().height : 0;
    notificacion.style.setProperty('--carrusel-novedades-desplazamiento-superior', alturaEncabezado + 'px');
  }

  posicionarNotificacionNovedadesDebajoDelEncabezado();
  window.addEventListener('resize', posicionarNotificacionNovedadesDebajoDelEncabezado);

  function mostrarNotificacionNovedades() {
    var notificacion = obtenerNotificacionNovedades();
    if (!notificacion) return;
    posicionarNotificacionNovedadesDebajoDelEncabezado();
    notificacion.classList.add('carrusel-novedades__notificacion-carrito--activa');
    if (temporizadorNotificacionNovedades) window.clearTimeout(temporizadorNotificacionNovedades);
    temporizadorNotificacionNovedades = window.setTimeout(function () {
      notificacion.classList.remove('carrusel-novedades__notificacion-carrito--activa');
    }, 5000);
  }

  document.addEventListener('click', function (evento) {
    var botonCerrar = evento.target.closest('[data-cerrar-notificacion-carrito]');
    if (!botonCerrar) return;
    var notificacion = obtenerNotificacionNovedades();
    if (!notificacion) return;
    notificacion.classList.remove('carrusel-novedades__notificacion-carrito--activa');
    if (temporizadorNotificacionNovedades) window.clearTimeout(temporizadorNotificacionNovedades);
  });

  function actualizarCajonCarritoTCV(secciones) {
    if (!secciones) return;
    var cajon = document.querySelector('cart-drawer');
    if (!cajon) return;
    var listaSecciones = [
      { id: 'cart-drawer', selector: '#CartDrawer' },
      { id: 'cart-icon-bubble', selector: null }
    ];
    listaSecciones.forEach(function (seccion) {
      var html = secciones[seccion.id];
      if (!html) return;
      var elementoDestino = seccion.selector
        ? document.querySelector(seccion.selector)
        : document.getElementById(seccion.id);
      if (!elementoDestino) return;
      var selectorInterno = seccion.selector || '.shopify-section';
      var documentoParseado = new DOMParser().parseFromString(html, 'text/html');
      var nodoFuente = documentoParseado.querySelector(selectorInterno);
      if (nodoFuente) elementoDestino.innerHTML = nodoFuente.innerHTML;
    });
    cajon.classList.remove('is-empty');
    var itemsCajon = cajon.querySelector('cart-drawer-items');
    if (itemsCajon) itemsCajon.classList.remove('is-empty');
    var overlayCajon = document.getElementById('CartDrawer-Overlay');
    if (overlayCajon && typeof cajon.close === 'function') {
      overlayCajon.addEventListener('click', cajon.close.bind(cajon));
    }
  }

  function obtenerConfigDeseosNovedades() {
    var config = window._ReStockConfig;
    if (!config || !config.customer || !config.wishlist || config.wishlist.is_service_active === false) {
      return null;
    }
    return config;
  }

  function sincronizarBotonesDeseosNovedades(seccion) {
    var botones = seccion.querySelectorAll('[data-boton-deseos]');
    if (!botones.length) return;
    var config = obtenerConfigDeseosNovedades();
    if (!config) {
      botones.forEach(function (boton) {
        boton.hidden = true;
      });
      return;
    }
    var variantesGuardadas = {};
    (config.customer.wishlists || []).forEach(function (listaDeseos) {
      (listaDeseos.items || []).forEach(function (articulo) {
        variantesGuardadas[String(articulo.variant_id)] = true;
      });
    });
    botones.forEach(function (boton) {
      boton.hidden = false;
      var idVariante = boton.getAttribute('data-variante-id');
      var estaGuardado = !!variantesGuardadas[String(idVariante)];
      boton.classList.toggle('carrusel-novedades__boton-deseos--activo', estaGuardado);
      boton.setAttribute('aria-pressed', estaGuardado ? 'true' : 'false');
    });
  }

  function inicializarCarruselNovedades(seccion) {
    var lista = seccion.querySelector('[data-carrusel-lista]');

    function desplazar(direccion) {
      if (!lista) return;
      lista.scrollBy({ left: direccion * lista.clientWidth * 0.9, behavior: 'smooth' });
    }

    var flechaAnterior = seccion.querySelector('[data-carrusel-flecha="anterior"]');
    var flechaSiguiente = seccion.querySelector('[data-carrusel-flecha="siguiente"]');
    if (flechaAnterior) {
      flechaAnterior.addEventListener('click', function () {
        desplazar(-1);
      });
    }
    if (flechaSiguiente) {
      flechaSiguiente.addEventListener('click', function () {
        desplazar(1);
      });
    }

    seccion.querySelectorAll('[data-carrusel-cantidad-menos], [data-carrusel-cantidad-mas]').forEach(function (botonCantidad) {
      botonCantidad.addEventListener('click', function () {
        var envoltura = botonCantidad.closest('[data-carrusel-cantidad-wrapper]');
        if (!envoltura) return;
        var input = envoltura.querySelector('[data-carrusel-cantidad-input]');
        if (!input) return;
        var valorActual = parseInt(input.value, 10);
        if (isNaN(valorActual) || valorActual < 1) valorActual = 1;
        if (botonCantidad.hasAttribute('data-carrusel-cantidad-mas')) {
          valorActual += 1;
        } else if (valorActual > 1) {
          valorActual -= 1;
        }
        input.value = valorActual;
      });
    });

    seccion.querySelectorAll('[data-carrusel-cantidad-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        var valor = parseInt(input.value, 10);
        if (isNaN(valor) || valor < 1) valor = 1;
        input.value = valor;
      });
    });

    seccion.querySelectorAll('[data-agregar-carrito]').forEach(function (boton) {
      boton.addEventListener('click', function (evento) {
        evento.preventDefault();
        evento.stopPropagation();
        if (boton.hasAttribute('disabled')) return;
        var idVariante = boton.getAttribute('data-variante-id');
        if (!idVariante || boton.hasAttribute('data-cargando')) return;
        boton.setAttribute('data-cargando', 'true');

        var cantidad = 1;
        var filaCarrito = boton.closest('.carrusel-novedades__fila-carrito');
        if (filaCarrito) {
          var inputCantidad = filaCarrito.querySelector('[data-carrusel-cantidad-input]');
          if (inputCantidad) {
            var valorCantidad = parseInt(inputCantidad.value, 10);
            if (!isNaN(valorCantidad) && valorCantidad > 0) cantidad = valorCantidad;
          }
        }

        var datosFormulario = new FormData();
        datosFormulario.append('id', idVariante);
        datosFormulario.append('quantity', cantidad);
        datosFormulario.append('sections', 'cart-drawer,cart-icon-bubble');
        datosFormulario.append('sections_url', window.location.pathname);

        var controladorTiempoLimite = new AbortController();
        var temporizadorTiempoLimite = window.setTimeout(function () {
          controladorTiempoLimite.abort();
        }, 12000);

        function finalizarEstadoBotonNovedades() {
          window.clearTimeout(temporizadorTiempoLimite);
          boton.removeAttribute('data-cargando');
          boton.classList.remove('carrusel-novedades__boton-carrito--exito');
          boton.blur();
        }

        fetch('/cart/add.js', {
          method: 'POST',
          body: datosFormulario,
          signal: controladorTiempoLimite.signal,
        })
          .then(function (respuesta) {
            return respuesta.json().then(function (datos) {
              if (!respuesta.ok || datos.status) {
                throw new Error(datos.description || datos.message || 'error');
              }
              return datos;
            });
          })
          .then(function (datos) {
            window.clearTimeout(temporizadorTiempoLimite);
            boton.removeAttribute('data-cargando');
            boton.classList.add('carrusel-novedades__boton-carrito--exito');
            try {
              actualizarCajonCarritoTCV(datos.sections);
            } catch (errorActualizacion) {
              console.error(errorActualizacion);
            }
            mostrarNotificacionNovedades();
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS === 'object') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'carrusel-novedades',
                productVariantId: idVariante,
                cartData: datos,
              });
            }
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            var inputCantidadReset = filaCarrito ? filaCarrito.querySelector('[data-carrusel-cantidad-input]') : null;
            if (inputCantidadReset) inputCantidadReset.value = 1;
            window.setTimeout(function () {
              boton.classList.remove('carrusel-novedades__boton-carrito--exito');
              boton.blur();
            }, 1600);
          })
          .catch(function (error) {
            console.error(error);
            finalizarEstadoBotonNovedades();
          });
      });
    });

    seccion.querySelectorAll('[data-boton-deseos]').forEach(function (boton) {
      boton.addEventListener('click', function (evento) {
        evento.preventDefault();
        evento.stopPropagation();
        if (boton.hasAttribute('data-cargando')) return;
        var config = obtenerConfigDeseosNovedades();
        if (!config) return;
        var idProducto = boton.getAttribute('data-producto-id');
        var idVariante = boton.getAttribute('data-variante-id');
        if (!idProducto || !idVariante) return;
        var estabaActivo = boton.classList.contains('carrusel-novedades__boton-deseos--activo');
        var accion = estabaActivo ? 'remove' : 'add';
        boton.setAttribute('data-cargando', 'true');

        fetch('https://api.notify-me.app/wishlist/wishlist-items/' + accion, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            shop_id: config.shop_id,
            variant_id: parseInt(idVariante, 10),
            product_id: parseInt(idProducto, 10),
            customer_id: config.customer.id,
          }),
        })
          .then(function (respuesta) {
            if (!respuesta.ok) throw new Error('error-boton-deseos');
            var listaActual = config.customer.wishlists && config.customer.wishlists[0];
            if (listaActual) {
              if (accion === 'add') {
                listaActual.items.push({
                  variant_id: parseInt(idVariante, 10),
                  product_id: parseInt(idProducto, 10),
                });
              } else {
                listaActual.items = (listaActual.items || []).filter(function (articulo) {
                  return String(articulo.variant_id) !== String(idVariante);
                });
              }
            }
            boton.classList.toggle('carrusel-novedades__boton-deseos--activo', accion === 'add');
            boton.setAttribute('aria-pressed', accion === 'add' ? 'true' : 'false');
          })
          .catch(function (error) {
            console.error(error);
          })
          .then(function () {
            boton.removeAttribute('data-cargando');
          });
      });
    });

    sincronizarBotonesDeseosNovedades(seccion);
  }

  document.querySelectorAll('[data-carrusel-novedades]').forEach(inicializarCarruselNovedades);

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (evento) {
      var seccion = evento.target.querySelector('[data-carrusel-novedades]');
      if (seccion) inicializarCarruselNovedades(seccion);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["franquicias"] && !Shopify.designMode) return;
  try {
    
(function () {
  function medirTrazos(seccion) {
    var trazos = seccion.querySelectorAll('.franquicias-seccion__boceto-trazo');
    trazos.forEach(function (trazo) {
      try {
        var longitud = trazo.getTotalLength();
        trazo.style.setProperty('--fq-boceto-len', longitud);
      } catch (error) {}
    });
  }

  function activarTransicion(seccion) {
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        seccion.classList.add('franquicias-seccion--boceto-listo');
      });
    });
  }

  function inicializarCarrusel(seccion) {
    var carrusel = seccion.querySelector('.franquicias-seccion__carrusel');
    if (!carrusel) return;
    var fila = carrusel.querySelector('.franquicias-seccion__fila');
    var flechaPrev = carrusel.querySelector('.franquicias-seccion__flecha--prev');
    var flechaNext = carrusel.querySelector('.franquicias-seccion__flecha--next');
    var autoplayActivo = carrusel.getAttribute('data-autoplay') === 'true';
    var velocidadMs = (parseFloat(carrusel.getAttribute('data-velocidad')) || 4) * 1000;
    var prefiereMenosMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var pausado = false;
    var enPantalla = true;
    var reanudarTimeout = null;
    var intervalo = null;

    function calcularAvance() {
      var items = fila.querySelectorAll('.franquicias-seccion__item');
      if (items.length < 2) return fila.clientWidth;
      return items[1].offsetLeft - items[0].offsetLeft;
    }

    function actualizarOverflow() {
      var tieneDesbordamiento = fila.scrollWidth > fila.clientWidth + 2;
      carrusel.classList.toggle('franquicias-seccion__carrusel--sin-desbordamiento', !tieneDesbordamiento);
    }

    function irSiguiente() {
      var maximo = fila.scrollWidth - fila.clientWidth;
      if (fila.scrollLeft >= maximo - 2) {
        fila.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        fila.scrollBy({ left: calcularAvance(), behavior: 'smooth' });
      }
    }

    function irAnterior() {
      if (fila.scrollLeft <= 2) {
        fila.scrollTo({ left: fila.scrollWidth - fila.clientWidth, behavior: 'smooth' });
      } else {
        fila.scrollBy({ left: -calcularAvance(), behavior: 'smooth' });
      }
    }

    function pausar() {
      pausado = true;
    }

    function programarReanudar(retraso) {
      clearTimeout(reanudarTimeout);
      reanudarTimeout = window.setTimeout(function () {
        pausado = false;
      }, retraso || 600);
    }

    if (flechaPrev) {
      flechaPrev.addEventListener('click', function () {
        irAnterior();
        pausar();
        programarReanudar(3500);
      });
    }

    if (flechaNext) {
      flechaNext.addEventListener('click', function () {
        irSiguiente();
        pausar();
        programarReanudar(3500);
      });
    }

    carrusel.addEventListener('mouseenter', pausar);
    carrusel.addEventListener('mouseleave', function () {
      programarReanudar(200);
    });
    fila.addEventListener('touchstart', pausar, { passive: true });
    fila.addEventListener('touchend', function () {
      programarReanudar(2500);
    }, { passive: true });
    fila.addEventListener('focusin', pausar);
    fila.addEventListener('focusout', function () {
      programarReanudar(1000);
    });

    if (window.IntersectionObserver) {
      var observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (entrada) {
          enPantalla = entrada.isIntersecting;
        });
      }, { threshold: 0.2 });
      observador.observe(carrusel);
    }

    window.addEventListener('resize', actualizarOverflow);
    actualizarOverflow();

    if (autoplayActivo && !prefiereMenosMovimiento) {
      intervalo = window.setInterval(function () {
        if (!pausado && enPantalla) {
          irSiguiente();
        }
      }, velocidadMs);
    }
  }

  function inicializarFranquicias(seccion) {
    medirTrazos(seccion);
    activarTransicion(seccion);
    inicializarCarrusel(seccion);
    var esTactil = window.matchMedia('(hover: none)').matches;
    if (!esTactil) return;
    var items = seccion.querySelectorAll('.franquicias-seccion__item');
    items.forEach(function (item) {
      item.addEventListener('click', function (evento) {
        var yaActivo = item.classList.contains('franquicias-seccion__item--activo');
        items.forEach(function (otro) {
          otro.classList.remove('franquicias-seccion__item--activo');
        });
        if (!yaActivo && item.getAttribute('href')) {
          evento.preventDefault();
          item.classList.add('franquicias-seccion__item--activo');
        }
      });
    });
  }

  document.querySelectorAll('.franquicias-seccion').forEach(inicializarFranquicias);

  document.addEventListener('shopify:section:load', function (evento) {
    var seccion = evento.target.querySelector('.franquicias-seccion');
    if (seccion) inicializarFranquicias(seccion);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(function () {
  function alInicializar() {
    var secciones = document.querySelectorAll('[data-cabecera-enterprise]');
    secciones.forEach(function (cabecera) {
      var botonAbrir = cabecera.querySelector('[data-abrir-menu-movil]');
      var botonCerrar = cabecera.querySelector('[data-cerrar-menu-movil]');
      var overlay = cabecera.querySelector('[data-overlay-menu-movil]');
      var menuMovil = cabecera.querySelector('[data-menu-movil]');

      function abrirMenu() {
        menuMovil.classList.add('cabecera-enterprise__menu-movil--visible');
        overlay.classList.add('cabecera-enterprise__overlay-movil--visible');
        document.body.style.overflow = 'hidden';
      }

      function cerrarSubmenusMovil() {
        var panelesAbiertos = cabecera.querySelectorAll('.cabecera-enterprise__submenu-movil--visible');
        panelesAbiertos.forEach(function (panel) {
          panel.classList.remove('cabecera-enterprise__submenu-movil--visible');
        });
      }

      function cerrarMenu() {
        menuMovil.classList.remove('cabecera-enterprise__menu-movil--visible');
        overlay.classList.remove('cabecera-enterprise__overlay-movil--visible');
        document.body.style.overflow = '';
        cerrarSubmenusMovil();
      }

      if (botonAbrir) botonAbrir.addEventListener('click', abrirMenu);
      if (botonCerrar) botonCerrar.addEventListener('click', cerrarMenu);
      if (overlay) overlay.addEventListener('click', cerrarMenu);

      document.addEventListener('keydown', function (evento) {
        if (evento.key === 'Escape') cerrarMenu();
      });

      var abrirSubmenusMovil = cabecera.querySelectorAll('[data-abrir-submenu-movil]');
      abrirSubmenusMovil.forEach(function (boton) {
        boton.addEventListener('click', function () {
          var item = boton.closest('.cabecera-enterprise__item-menu-movil');
          var panel = item ? item.querySelector('[data-panel-submenu-movil]') : null;
          if (panel) panel.classList.add('cabecera-enterprise__submenu-movil--visible');
        });
      });

      var cerrarSubmenusMovilBotones = cabecera.querySelectorAll('[data-cerrar-submenu-movil]');
      cerrarSubmenusMovilBotones.forEach(function (boton) {
        boton.addEventListener('click', function () {
          var panel = boton.closest('.cabecera-enterprise__submenu-movil');
          if (panel) panel.classList.remove('cabecera-enterprise__submenu-movil--visible');
        });
      });

      var itemsConSubmenu = cabecera.querySelectorAll('.cabecera-enterprise__item-menu--con-submenu');
      itemsConSubmenu.forEach(function (item) {
        var enlace = item.querySelector(':scope > .cabecera-enterprise__enlace-menu');
        enlace.addEventListener('click', function (evento) {
          if (window.matchMedia('(hover: none)').matches) {
            evento.preventDefault();
            item.classList.toggle('cabecera-enterprise__item-menu--abierto');
          }
        });
      });

      var disparadorCuenta = cabecera.querySelector('[data-cuenta-disparador]');
      if (disparadorCuenta) {
        var envoltorioCuenta = disparadorCuenta.closest('.cabecera-enterprise__cuenta-envoltorio');

        function cerrarMenuCuenta() {
          envoltorioCuenta.classList.remove('cabecera-enterprise__cuenta-envoltorio--abierto');
          disparadorCuenta.setAttribute('aria-expanded', 'false');
        }

        disparadorCuenta.addEventListener('click', function (evento) {
          if (window.matchMedia('(hover: none)').matches) {
            evento.preventDefault();
            var abierto = envoltorioCuenta.classList.toggle('cabecera-enterprise__cuenta-envoltorio--abierto');
            disparadorCuenta.setAttribute('aria-expanded', abierto ? 'true' : 'false');
          }
        });

        document.addEventListener('click', function (evento) {
          if (!envoltorioCuenta.contains(evento.target)) cerrarMenuCuenta();
        });

        document.addEventListener('keydown', function (evento) {
          if (evento.key === 'Escape') cerrarMenuCuenta();
        });
      }

      var botonesCopiar = cabecera.querySelectorAll('[data-copiar-codigo]');
      botonesCopiar.forEach(function (boton) {
        boton.addEventListener('click', function (evento) {
          evento.preventDefault();
          var codigo = boton.getAttribute('data-copiar-codigo');
          var textoBoton = boton.querySelector('[data-texto-copiar-boton]');
          var textoOriginal = textoBoton.textContent;

          function marcarCopiado() {
            textoBoton.textContent = '¡Copiado!';
            setTimeout(function () {
              textoBoton.textContent = textoOriginal;
            }, 2000);
          }

          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(codigo).then(marcarCopiado);
          } else {
            var campoTemporal = document.createElement('textarea');
            campoTemporal.value = codigo;
            document.body.appendChild(campoTemporal);
            campoTemporal.select();
            document.execCommand('copy');
            document.body.removeChild(campoTemporal);
            marcarCopiado();
          }
        });
      });

      var scriptFrases = cabecera.querySelector('[data-frases-buscador]');
      var elementosTextoAnimado = cabecera.querySelectorAll('[data-texto-animado]');

      if (scriptFrases && elementosTextoAnimado.length > 0) {
        var frases = [];
        try {
          frases = JSON.parse(scriptFrases.textContent).filter(function (frase) {
            return frase && frase.trim().length > 0;
          });
        } catch (error) {
          frases = [];
        }

        if (frases.length > 0) {
          elementosTextoAnimado.forEach(function (elementoTexto) {
            var campo = elementoTexto.closest('.cabecera-enterprise__campo-buscador, .cabecera-enterprise__campo-buscador-movil');
            var input = campo ? campo.querySelector('[data-input-buscador]') : null;
            if (!input) return;

            var indiceFrase = 0;
            var indiceCaracter = 0;
            var borrando = false;
            var temporizador = null;
            var activo = true;

            var velocidadEscritura = 55;
            var velocidadBorrado = 30;
            var pausaFinal = 1600;
            var pausaInicial = 400;

            function debeEstarPausado() {
              return document.activeElement === input || input.value.trim().length > 0;
            }

            function ciclo() {
              if (!activo) return;

              if (debeEstarPausado()) {
                pausar();
                return;
              }

              var fraseActual = frases[indiceFrase];

              if (!borrando) {
                indiceCaracter++;
                elementoTexto.textContent = fraseActual.slice(0, indiceCaracter);

                if (indiceCaracter === fraseActual.length) {
                  temporizador = setTimeout(function () {
                    borrando = true;
                    ciclo();
                  }, pausaFinal);
                  return;
                }

                temporizador = setTimeout(ciclo, velocidadEscritura);
              } else {
                indiceCaracter--;
                elementoTexto.textContent = fraseActual.slice(0, indiceCaracter);

                if (indiceCaracter === 0) {
                  borrando = false;
                  indiceFrase = (indiceFrase + 1) % frases.length;
                  temporizador = setTimeout(ciclo, pausaInicial);
                  return;
                }

                temporizador = setTimeout(ciclo, velocidadBorrado);
              }
            }

            function pausar() {
              activo = false;
              if (temporizador) clearTimeout(temporizador);
              elementoTexto.textContent = '';
              elementoTexto.classList.add('cabecera-enterprise__texto-animado--oculto');
            }

            function reanudar() {
              if (debeEstarPausado()) return;
              activo = true;
              elementoTexto.classList.remove('cabecera-enterprise__texto-animado--oculto');
              temporizador = setTimeout(ciclo, velocidadEscritura);
            }

            input.addEventListener('focus', pausar);
            input.addEventListener('input', function () {
              if (input.value.trim().length > 0) {
                pausar();
              }
            });
            input.addEventListener('blur', reanudar);

            if (debeEstarPausado()) {
              pausar();
            } else {
              temporizador = setTimeout(ciclo, velocidadEscritura);
            }
          });
        }
      }

      var formularios = cabecera.querySelectorAll('[data-form-buscador]');
      formularios.forEach(function (formulario) {
        var input = formulario.querySelector('[data-input-buscador]');
        var contenedorResultados = formulario.querySelector('[data-resultados-buscador]');
        if (!input || !contenedorResultados) return;

        var temporizadorBusqueda = null;
        var controladorPeticion = null;

        function ocultarResultados() {
          contenedorResultados.classList.remove('cabecera-enterprise__resultados-buscador--visible');
        }

        function mostrarResultados() {
          contenedorResultados.classList.add('cabecera-enterprise__resultados-buscador--visible');
        }

        function escaparHtml(texto) {
          var div = document.createElement('div');
          div.textContent = texto;
          return div.innerHTML;
        }

        function renderizarResultados(productos, termino) {
          if (!productos || productos.length === 0) {
            contenedorResultados.innerHTML = '<div class="cabecera-enterprise__resultado-vacio">Sin resultados para &ldquo;' + escaparHtml(termino) + '&rdquo;</div>';
            mostrarResultados();
            return;
          }

          var html = productos.map(function (producto) {
            var imagenHtml = producto.image
              ? '<img src="' + producto.image + '" alt="' + escaparHtml(producto.title) + '" loading="lazy" width="48" height="48">'
              : '';
            return (
              '<a href="' + producto.url + '" class="cabecera-enterprise__resultado-item">' +
                '<span class="cabecera-enterprise__resultado-imagen">' + imagenHtml + '</span>' +
                '<span class="cabecera-enterprise__resultado-info">' +
                  '<span class="cabecera-enterprise__resultado-titulo">' + escaparHtml(producto.title) + '</span>' +
                  '<span class="cabecera-enterprise__resultado-precio">' + producto.price + '</span>' +
                '</span>' +
              '</a>'
            );
          }).join('');

          contenedorResultados.innerHTML = html;
          mostrarResultados();
        }

        function buscarProductos(termino) {
          if (controladorPeticion) controladorPeticion.abort();
          controladorPeticion = new AbortController();

          var url = '/search/suggest.json?q=' + encodeURIComponent(termino) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';

          fetch(url, { signal: controladorPeticion.signal })
            .then(function (respuesta) {
              return respuesta.json();
            })
            .then(function (datos) {
              var productos = [];
              if (datos && datos.resources && datos.resources.results && datos.resources.results.products) {
                productos = datos.resources.results.products;
              }
              renderizarResultados(productos, termino);
            })
            .catch(function (error) {
              if (error.name !== 'AbortError') {
                ocultarResultados();
              }
            });
        }

        input.addEventListener('input', function () {
          var termino = input.value.trim();

          if (temporizadorBusqueda) clearTimeout(temporizadorBusqueda);

          if (termino.length < 2) {
            ocultarResultados();
            return;
          }

          temporizadorBusqueda = setTimeout(function () {
            buscarProductos(termino);
          }, 300);
        });

        input.addEventListener('focus', function () {
          if (input.value.trim().length >= 2 && contenedorResultados.innerHTML.trim() !== '') {
            mostrarResultados();
          }
        });

        document.addEventListener('click', function (evento) {
          if (!formulario.contains(evento.target)) {
            ocultarResultados();
          }
        });

        document.addEventListener('keydown', function (evento) {
          if (evento.key === 'Escape') ocultarResultados();
        });
      });

      var umbralCabeceraCompacta = 80;
      var cabeceraEsCompacta = false;
      var tickScrollCabecera = false;

      function actualizarCabeceraCompacta() {
        var debeSerCompacta = window.scrollY > umbralCabeceraCompacta;
        if (debeSerCompacta !== cabeceraEsCompacta) {
          cabeceraEsCompacta = debeSerCompacta;
          cabecera.classList.toggle('cabecera-enterprise--compacta', cabeceraEsCompacta);
          if (!cabeceraEsCompacta) {
            cerrarMenu();
          }
        }
        tickScrollCabecera = false;
      }

      function alHacerScrollCabecera() {
        if (!tickScrollCabecera) {
          window.requestAnimationFrame(actualizarCabeceraCompacta);
          tickScrollCabecera = true;
        }
      }

      window.addEventListener('scroll', alHacerScrollCabecera, { passive: true });
      actualizarCabeceraCompacta();

      var enlaceCarrito = cabecera.querySelector('.cabecera-enterprise__icono-carrito');
      var iconoSvgCarrito = enlaceCarrito ? enlaceCarrito.querySelector('.cabecera-enterprise__icono-svg') : null;

      var conteoAnteriorCarrito = 0;
      if (iconoSvgCarrito) {
        var contadorInicialCarrito = iconoSvgCarrito.querySelector('.cabecera-enterprise__contador-carrito');
        if (contadorInicialCarrito) {
          conteoAnteriorCarrito = parseInt(contadorInicialCarrito.textContent, 10) || 0;
        }
      }

      function actualizarContadorCarrito(cantidad, animarContador) {
        if (!iconoSvgCarrito) return;
        var contador = iconoSvgCarrito.querySelector('.cabecera-enterprise__contador-carrito');
        if (cantidad > 0) {
          if (!contador) {
            contador = document.createElement('span');
            contador.className = 'cabecera-enterprise__contador-carrito';
            iconoSvgCarrito.appendChild(contador);
          }
          contador.textContent = cantidad;
          if (animarContador) {
            contador.classList.remove('cabecera-enterprise__contador-carrito--animar');
            void contador.offsetWidth;
            contador.classList.add('cabecera-enterprise__contador-carrito--animar');
          }
        } else if (contador) {
          contador.remove();
        }
      }

      function animarIconoCarrito() {
        if (!iconoSvgCarrito) return;
        iconoSvgCarrito.classList.remove('cabecera-enterprise__icono-svg--animar-carrito');
        void iconoSvgCarrito.offsetWidth;
        iconoSvgCarrito.classList.add('cabecera-enterprise__icono-svg--animar-carrito');
        if (enlaceCarrito) {
          enlaceCarrito.classList.remove('cabecera-enterprise__icono-carrito--animar-color');
          void enlaceCarrito.offsetWidth;
          enlaceCarrito.classList.add('cabecera-enterprise__icono-carrito--animar-color');
        }
      }

      if (enlaceCarrito) {
        var cajonCarrito = document.querySelector('cart-drawer');
        if (cajonCarrito) {
          enlaceCarrito.setAttribute('aria-haspopup', 'dialog');
          enlaceCarrito.addEventListener('click', function (evento) {
            evento.preventDefault();
            cajonCarrito.setActiveElement(enlaceCarrito);
            cajonCarrito.open(enlaceCarrito);
          });
        }
      }

      var temporizadorActualizacionCarrito = null;
      function sincronizarContadorCarrito() {
        if (temporizadorActualizacionCarrito) return;
        temporizadorActualizacionCarrito = window.setTimeout(function () {
          temporizadorActualizacionCarrito = null;
          fetch('/cart.js')
            .then(function (respuesta) {
              return respuesta.json();
            })
            .then(function (carrito) {
              var seAgrego = carrito.item_count > conteoAnteriorCarrito;
              actualizarContadorCarrito(carrito.item_count, seAgrego);
              if (seAgrego) {
                animarIconoCarrito();
              }
              conteoAnteriorCarrito = carrito.item_count;
            })
            .catch(function () {});
        }, 150);
      }

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, sincronizarContadorCarrito);
      }

      if (!window.cabeceraEnterpriseFetchCarritoParcheado) {
        window.cabeceraEnterpriseFetchCarritoParcheado = true;
        var fetchOriginalCabeceraEnterprise = window.fetch;
        window.fetch = function () {
          var peticionCabeceraEnterprise = fetchOriginalCabeceraEnterprise.apply(this, arguments);
          try {
            var urlPeticionCabeceraEnterprise = arguments[0];
            if (urlPeticionCabeceraEnterprise && typeof urlPeticionCabeceraEnterprise !== 'string' && urlPeticionCabeceraEnterprise.url) {
              urlPeticionCabeceraEnterprise = urlPeticionCabeceraEnterprise.url;
            }
            if (typeof urlPeticionCabeceraEnterprise === 'string' && /\/cart\/(add|change|update|clear)/.test(urlPeticionCabeceraEnterprise)) {
              peticionCabeceraEnterprise.then(function () {
                document.dispatchEvent(new CustomEvent('cabecera-enterprise:carrito-modificado'));
              }).catch(function () {});
            }
          } catch (errorCabeceraEnterprise) {}
          return peticionCabeceraEnterprise;
        };
      }

      document.addEventListener('cabecera-enterprise:carrito-modificado', sincronizarContadorCarrito);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alInicializar);
  } else {
    alInicializar();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-list-collections"]) return;
  try {
    
(function () {
  function medirTrazos(contenedor) {
    var trazos = contenedor.querySelectorAll('.lista-marcas__boceto-trazo');
    trazos.forEach(function (trazo) {
      try {
        var longitud = trazo.getTotalLength();
        trazo.style.setProperty('--lm-boceto-len', longitud);
      } catch (error) {}
    });
  }

  function activarTransicion(contenedor) {
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        contenedor.classList.add('lista-marcas--boceto-listo');
      });
    });
  }

  function inicializarListaMarcas(contenedor) {
    medirTrazos(contenedor);
    activarTransicion(contenedor);
    var esTactil = window.matchMedia('(hover: none)').matches;
    if (!esTactil) return;
    var tarjetas = contenedor.querySelectorAll('.lista-marcas__tarjeta');
    tarjetas.forEach(function (tarjeta) {
      tarjeta.addEventListener('click', function (evento) {
        var yaActiva = tarjeta.classList.contains('lista-marcas__tarjeta--activa');
        tarjetas.forEach(function (otra) {
          otra.classList.remove('lista-marcas__tarjeta--activa');
        });
        if (!yaActiva && tarjeta.getAttribute('href')) {
          evento.preventDefault();
          tarjeta.classList.add('lista-marcas__tarjeta--activa');
        }
      });
    });
  }

  document.querySelectorAll('.lista-marcas').forEach(inicializarListaMarcas);

  document.addEventListener('shopify:section:load', function (evento) {
    var contenedor = evento.target.querySelector('.lista-marcas');
    if (contenedor) inicializarListaMarcas(contenedor);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marcas"] && !Shopify.designMode) return;
  try {
    
(function () {
  function medirTrazos(seccion) {
    var trazos = seccion.querySelectorAll('.marcas-seccion__boceto-trazo');
    trazos.forEach(function (trazo) {
      try {
        var longitud = trazo.getTotalLength();
        trazo.style.setProperty('--mc-boceto-len', longitud);
      } catch (error) {}
    });
  }

  function activarTransicion(seccion) {
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        seccion.classList.add('marcas-seccion--boceto-listo');
      });
    });
  }

  function inicializarCarrusel(seccion) {
    var carrusel = seccion.querySelector('.marcas-seccion__carrusel');
    if (!carrusel) return;
    var fila = carrusel.querySelector('.marcas-seccion__fila');
    var flechaPrev = carrusel.querySelector('.marcas-seccion__flecha--prev');
    var flechaNext = carrusel.querySelector('.marcas-seccion__flecha--next');
    var autoplayActivo = carrusel.getAttribute('data-autoplay') === 'true';
    var velocidadMs = (parseFloat(carrusel.getAttribute('data-velocidad')) || 4) * 1000;
    var prefiereMenosMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var pausado = false;
    var enPantalla = true;
    var reanudarTimeout = null;
    var intervalo = null;

    function calcularAvance() {
      var items = fila.querySelectorAll('.marcas-seccion__item');
      if (items.length < 2) return fila.clientWidth;
      return items[1].offsetLeft - items[0].offsetLeft;
    }

    function actualizarOverflow() {
      var tieneDesbordamiento = fila.scrollWidth > fila.clientWidth + 2;
      carrusel.classList.toggle('marcas-seccion__carrusel--sin-desbordamiento', !tieneDesbordamiento);
    }

    function irSiguiente() {
      var maximo = fila.scrollWidth - fila.clientWidth;
      if (fila.scrollLeft >= maximo - 2) {
        fila.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        fila.scrollBy({ left: calcularAvance(), behavior: 'smooth' });
      }
    }

    function irAnterior() {
      if (fila.scrollLeft <= 2) {
        fila.scrollTo({ left: fila.scrollWidth - fila.clientWidth, behavior: 'smooth' });
      } else {
        fila.scrollBy({ left: -calcularAvance(), behavior: 'smooth' });
      }
    }

    function pausar() {
      pausado = true;
    }

    function programarReanudar(retraso) {
      clearTimeout(reanudarTimeout);
      reanudarTimeout = window.setTimeout(function () {
        pausado = false;
      }, retraso || 600);
    }

    if (flechaPrev) {
      flechaPrev.addEventListener('click', function () {
        irAnterior();
        pausar();
        programarReanudar(3500);
      });
    }

    if (flechaNext) {
      flechaNext.addEventListener('click', function () {
        irSiguiente();
        pausar();
        programarReanudar(3500);
      });
    }

    carrusel.addEventListener('mouseenter', pausar);
    carrusel.addEventListener('mouseleave', function () {
      programarReanudar(200);
    });
    fila.addEventListener('touchstart', pausar, { passive: true });
    fila.addEventListener('touchend', function () {
      programarReanudar(2500);
    }, { passive: true });
    fila.addEventListener('focusin', pausar);
    fila.addEventListener('focusout', function () {
      programarReanudar(1000);
    });

    if (window.IntersectionObserver) {
      var observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (entrada) {
          enPantalla = entrada.isIntersecting;
        });
      }, { threshold: 0.2 });
      observador.observe(carrusel);
    }

    window.addEventListener('resize', actualizarOverflow);
    actualizarOverflow();

    if (autoplayActivo && !prefiereMenosMovimiento) {
      intervalo = window.setInterval(function () {
        if (!pausado && enPantalla) {
          irSiguiente();
        }
      }, velocidadMs);
    }
  }

  function inicializarMarcas(seccion) {
    medirTrazos(seccion);
    activarTransicion(seccion);
    inicializarCarrusel(seccion);
    var esTactil = window.matchMedia('(hover: none)').matches;
    if (!esTactil) return;
    var items = seccion.querySelectorAll('.marcas-seccion__item');
    items.forEach(function (item) {
      item.addEventListener('click', function (evento) {
        var yaActivo = item.classList.contains('marcas-seccion__item--activo');
        items.forEach(function (otro) {
          otro.classList.remove('marcas-seccion__item--activo');
        });
        if (!yaActivo && item.getAttribute('href')) {
          evento.preventDefault();
          item.classList.add('marcas-seccion__item--activo');
        }
      });
    });
  }

  document.querySelectorAll('.marcas-seccion').forEach(inicializarMarcas);

  document.addEventListener('shopify:section:load', function (evento) {
    var seccion = evento.target.querySelector('.marcas-seccion');
    if (seccion) inicializarMarcas(seccion);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pie-pagina"] && !Shopify.designMode) return;
  try {
    
(function () {
  function inicializarPiePagina(pie) {
    var boton = pie.querySelector('[data-pie-pagina-arriba]');
    if (!boton) return;
    boton.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
  document.querySelectorAll('.pie-pagina').forEach(inicializarPiePagina);
  document.addEventListener('shopify:section:load', function (evento) {
    var pie = evento.target.querySelector('.pie-pagina');
    if (pie) inicializarPiePagina(pie);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
(function () {
  var temporizadorNotificacionRelacionados = null;

  function obtenerNotificacionRelacionados() {
    return document.getElementById('productos-relacionados-notificacion-carrito');
  }

  var notificacionRelacionadosMovidaAlBody = obtenerNotificacionRelacionados();
  if (notificacionRelacionadosMovidaAlBody && notificacionRelacionadosMovidaAlBody.parentNode !== document.body) {
    document.body.appendChild(notificacionRelacionadosMovidaAlBody);
  }

  function posicionarNotificacionRelacionadosDebajoDelEncabezado() {
    var notificacion = obtenerNotificacionRelacionados();
    if (!notificacion) return;
    var encabezado = document.querySelector('.cabecera-enterprise') || document.getElementById('shopify-section-header');
    var alturaEncabezado = encabezado ? encabezado.getBoundingClientRect().height : 0;
    notificacion.style.setProperty('--productos-relacionados-desplazamiento-superior', alturaEncabezado + 'px');
  }

  posicionarNotificacionRelacionadosDebajoDelEncabezado();
  window.addEventListener('resize', posicionarNotificacionRelacionadosDebajoDelEncabezado);

  function mostrarNotificacionRelacionados() {
    var notificacion = obtenerNotificacionRelacionados();
    if (!notificacion) return;
    posicionarNotificacionRelacionadosDebajoDelEncabezado();
    notificacion.classList.add('productos-relacionados__notificacion-carrito--activa');
    if (temporizadorNotificacionRelacionados) window.clearTimeout(temporizadorNotificacionRelacionados);
    temporizadorNotificacionRelacionados = window.setTimeout(function () {
      notificacion.classList.remove('productos-relacionados__notificacion-carrito--activa');
    }, 5000);
  }

  document.addEventListener('click', function (evento) {
    var botonCerrar = evento.target.closest('[data-cerrar-notificacion-productos-relacionados]');
    if (!botonCerrar) return;
    var notificacion = obtenerNotificacionRelacionados();
    if (!notificacion) return;
    notificacion.classList.remove('productos-relacionados__notificacion-carrito--activa');
    if (temporizadorNotificacionRelacionados) window.clearTimeout(temporizadorNotificacionRelacionados);
  });

  function actualizarCajonCarritoTCV(secciones) {
    if (!secciones) return;
    var cajon = document.querySelector('cart-drawer');
    if (!cajon) return;
    var listaSecciones = [
      { id: 'cart-drawer', selector: '#CartDrawer' },
      { id: 'cart-icon-bubble', selector: null }
    ];
    listaSecciones.forEach(function (seccion) {
      var html = secciones[seccion.id];
      if (!html) return;
      var elementoDestino = seccion.selector
        ? document.querySelector(seccion.selector)
        : document.getElementById(seccion.id);
      if (!elementoDestino) return;
      var selectorInterno = seccion.selector || '.shopify-section';
      var documentoParseado = new DOMParser().parseFromString(html, 'text/html');
      var nodoFuente = documentoParseado.querySelector(selectorInterno);
      if (nodoFuente) elementoDestino.innerHTML = nodoFuente.innerHTML;
    });
    cajon.classList.remove('is-empty');
    var itemsCajon = cajon.querySelector('cart-drawer-items');
    if (itemsCajon) itemsCajon.classList.remove('is-empty');
    var overlayCajon = document.getElementById('CartDrawer-Overlay');
    if (overlayCajon && typeof cajon.close === 'function') {
      overlayCajon.addEventListener('click', cajon.close.bind(cajon));
    }
  }

  function inicializarProductosRelacionados(contenedor) {
    if (contenedor.dataset.productosRelacionadosListo) return;
    contenedor.dataset.productosRelacionadosListo = 'true';

    var lista = contenedor.querySelector('[data-productos-relacionados-lista]');

    function desplazar(direccion) {
      if (!lista) return;
      lista.scrollBy({ left: direccion * lista.clientWidth * 0.9, behavior: 'smooth' });
    }

    var flechaAnterior = contenedor.querySelector('[data-productos-relacionados-flecha="anterior"]');
    var flechaSiguiente = contenedor.querySelector('[data-productos-relacionados-flecha="siguiente"]');
    if (flechaAnterior) {
      flechaAnterior.addEventListener('click', function () {
        desplazar(-1);
      });
    }
    if (flechaSiguiente) {
      flechaSiguiente.addEventListener('click', function () {
        desplazar(1);
      });
    }

    contenedor.querySelectorAll('[data-productos-relacionados-cantidad-menos], [data-productos-relacionados-cantidad-mas]').forEach(function (botonCantidad) {
      botonCantidad.addEventListener('click', function () {
        var envoltura = botonCantidad.closest('[data-productos-relacionados-cantidad-wrapper]');
        if (!envoltura) return;
        var input = envoltura.querySelector('[data-productos-relacionados-cantidad-input]');
        if (!input) return;
        var valorActual = parseInt(input.value, 10);
        if (isNaN(valorActual) || valorActual < 1) valorActual = 1;
        if (botonCantidad.hasAttribute('data-productos-relacionados-cantidad-mas')) {
          valorActual += 1;
        } else if (valorActual > 1) {
          valorActual -= 1;
        }
        input.value = valorActual;
      });
    });

    contenedor.querySelectorAll('[data-productos-relacionados-cantidad-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        var valor = parseInt(input.value, 10);
        if (isNaN(valor) || valor < 1) valor = 1;
        input.value = valor;
      });
    });

    contenedor.querySelectorAll('[data-productos-relacionados-agregar-carrito]').forEach(function (boton) {
      boton.addEventListener('click', function (evento) {
        evento.preventDefault();
        evento.stopPropagation();
        if (boton.hasAttribute('disabled')) return;
        var idVariante = boton.getAttribute('data-variante-id');
        if (!idVariante || boton.hasAttribute('data-cargando')) return;
        boton.setAttribute('data-cargando', 'true');

        var cantidad = 1;
        var filaCarrito = boton.closest('.productos-relacionados__fila-carrito');
        if (filaCarrito) {
          var inputCantidad = filaCarrito.querySelector('[data-productos-relacionados-cantidad-input]');
          if (inputCantidad) {
            var valorCantidad = parseInt(inputCantidad.value, 10);
            if (!isNaN(valorCantidad) && valorCantidad > 0) cantidad = valorCantidad;
          }
        }

        var datosFormulario = new FormData();
        datosFormulario.append('id', idVariante);
        datosFormulario.append('quantity', cantidad);
        datosFormulario.append('sections', 'cart-drawer,cart-icon-bubble');
        datosFormulario.append('sections_url', window.location.pathname);

        var controladorTiempoLimite = new AbortController();
        var temporizadorTiempoLimite = window.setTimeout(function () {
          controladorTiempoLimite.abort();
        }, 12000);

        function finalizarEstadoBotonRelacionados() {
          window.clearTimeout(temporizadorTiempoLimite);
          boton.removeAttribute('data-cargando');
          boton.classList.remove('productos-relacionados__boton-carrito--exito');
          boton.blur();
        }

        fetch('/cart/add.js', {
          method: 'POST',
          body: datosFormulario,
          signal: controladorTiempoLimite.signal,
        })
          .then(function (respuesta) {
            return respuesta.json().then(function (datos) {
              if (!respuesta.ok || datos.status) {
                throw new Error(datos.description || datos.message || 'error');
              }
              return datos;
            });
          })
          .then(function (datos) {
            window.clearTimeout(temporizadorTiempoLimite);
            boton.removeAttribute('data-cargando');
            boton.classList.add('productos-relacionados__boton-carrito--exito');
            try {
              actualizarCajonCarritoTCV(datos.sections);
            } catch (errorActualizacion) {
              console.error(errorActualizacion);
            }
            mostrarNotificacionRelacionados();
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS === 'object') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'productos-relacionados',
                productVariantId: idVariante,
                cartData: datos,
              });
            }
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            var inputCantidadReset = filaCarrito ? filaCarrito.querySelector('[data-productos-relacionados-cantidad-input]') : null;
            if (inputCantidadReset) inputCantidadReset.value = 1;
            window.setTimeout(function () {
              boton.classList.remove('productos-relacionados__boton-carrito--exito');
              boton.blur();
            }, 1600);
          })
          .catch(function (error) {
            console.error(error);
            finalizarEstadoBotonRelacionados();
          });
      });
    });
  }

  function buscarEInicializar(raiz) {
    raiz = raiz || document;
    raiz.querySelectorAll('[data-product-recomendados]').forEach(inicializarProductosRelacionados);
  }

  buscarEInicializar();

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (evento) {
      buscarEInicializar(evento.target);
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
